'use strict';

import MaterialDesign from '../../_js/common/_material-design';
import { debounce, easeOutExpo } from '../../_js/common/_util';

export default class Navigation {
    constructor() {
        const self = this;
        const $body = $('body');
        const el = $('#navigation');
        const $nav = el.find('.nav');
        const $lvl1 = el.find('.lvl1');
        const $lvl2 = el.find('.lvl2');
        const $lvl3 = el.find('.lvl3');
        const $set = $lvl1.add($lvl2).add($lvl3);
        const $primaryNav = $('.js-mobile-menu');
        const subNavMarkup = '<button class="sub-nav js-sub-nav icon-arrow" name="Sub-navigation"></button>';

        self.material = new MaterialDesign();
        self.$window = $(window);
        self.$visibleArea = 0;


        // Insert Subnav Markup after Level 1 menu items
        $lvl1.find('ol').each(function () {
            $(this).before(subNavMarkup);
        });

        self.checkNavHeight();

        $primaryNav.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $this = $(this);

            el.toggleClass('active');
            $this.toggleClass('active');
            $nav.toggleClass('active');
            $lvl1.toggleClass('active');

            if ($this.hasClass('active')) {
                $lvl1.slideDown(easeOutExpo);
            } else {
                $set
                    .removeClass('active')
                    .find('.icon-arrow.active')
                    .removeClass('active');

                $lvl2.slideUp(easeOutExpo);
                $lvl3.slideUp(easeOutExpo);
            }
        });

        $body.on('click', function (e) {
            const $eTarget = $(e.target);

            if ($eTarget.hasClass('nav active') && !$eTarget.parents('.nav').length) {
                if ($primaryNav.hasClass('active')) {
                    $primaryNav.trigger('click');
                }

                $('.js-sub-nav.active').trigger('click');
            }
        });


        $('#navigation .lvl1 a').on('click', function (e) {
            if ($primaryNav.hasClass('active')) {
                $primaryNav.trigger('click');
            }
        });

        $('#navigation .lvl1 a.-embed').on('click', function (e) {
            e.preventDefault();

            var copyText = document.getElementById("embedCode");
            copyText.select();
            document.execCommand("copy");

            self.material.toaster('Embed code has been copied to your clipboard.');
        })

        // Window Listener
        self.$window.on('resize', debounce(function () {
            $primaryNav.removeClass('active');
            $set
                .find('.icon-arrow.active')
                .removeClass('active');

            $nav.removeClass('active');
            $lvl1.removeClass('active');
            $lvl2.hide();
            $lvl3.hide();
        }, 250));
    }

    checkNavHeight() {
        const self = this;
        const $navLvl1 = $('#navigation .lvl1');

        self.$visibleArea = self.$window.outerHeight() - $('.header').outerHeight();

        $navLvl1.css({
            height: self.$visibleArea
        });
    }
}
